
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false,
    },
  }, 
  data() {
    return {
      id: null,
      modelId: null,
      environmentId: null,
      slug: null,
      type: null,
      title: null,
      description: null,
      hero: null,

      showDialog: false,
    }
  },
  computed: {
    dialogTitle () {
      let title = ""
      switch (this.type) {
        case "person":
          title = 'Volg deze persoon'
          break;
        case 'program':
          title = 'Volg dit programma'
          break;
        default:
          title = ''
      }
      
      return title
    },
    isUserLoggedIn () {
      return this.$auth.loggedIn
    },
  },
  watch: {
    isOpen (newState) {
      this.showDialog = newState
    },
  },
  async mounted () {
    window.addEventListener('follow-guide', this.onFollowGuide)
  },
  beforeDestroy () {
    window.removeEventListener('follow-guide', this.onFollowGuide)
  },
  methods: {
    onClose () {
      this.showDialog = false
    },
    onFollowGuide (evt) {
      const followData = evt.detail 

      if (followData) {
        this.id = followData.id
        this.modelId = followData.modelId
        this.environmentId = followData.environmentId
        this.slug = followData.slug
        this.type = followData.type
        this.title = followData.title || followData.name
        this.description = followData.description
        this.hero = followData.hero

        this.showDialog = true
      }
    },
  },
}
